var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch, Component } from 'vue-property-decorator';
import CategoryService from '../../../api/CategoryService';
var DistributionLeftTree = (function (_super) {
    __extends(DistributionLeftTree, _super);
    function DistributionLeftTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterText = "";
        _this.defaultProps = {
            label: 'goods_type_name',
            id: "goods_type_id"
        };
        return _this;
    }
    DistributionLeftTree.prototype.watchFilter = function (val) {
        this.$refs.tree.filter(val);
    };
    DistributionLeftTree.prototype.watchData = function (val, oldVal) {
        var _this = this;
        if (this.data && this.data.length && !oldVal.length) {
            this.$nextTick(function () {
                _this.$refs.tree.setCurrentKey(_this.data[0].goods_type_id);
                _this.$emit('node-click', _this.$refs.tree.getCurrentNode());
            });
        }
    };
    DistributionLeftTree.prototype.created = function () {
        this.service = CategoryService.getInstance();
    };
    DistributionLeftTree.prototype.mounted = function () {
        var height = 300;
        this.$refs.tree.$el.style.maxHeight = height + 'px';
    };
    DistributionLeftTree.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.goods_type_name.indexOf(value) !== -1;
    };
    DistributionLeftTree.prototype.nodeClick = function (data, node, target) {
        data.account_val_times = 0;
        this.$emit('node-click', data);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], DistributionLeftTree.prototype, "data", void 0);
    __decorate([
        Watch("filterText")
    ], DistributionLeftTree.prototype, "watchFilter", null);
    __decorate([
        Watch("data")
    ], DistributionLeftTree.prototype, "watchData", null);
    DistributionLeftTree = __decorate([
        Component
    ], DistributionLeftTree);
    return DistributionLeftTree;
}(Vue));
export default DistributionLeftTree;
